import React, { useCallback, useEffect, useMemo } from 'react';
import { translate } from '@shakkerai/util-i18n';
import { useLoadings } from '@shakkerai/pro-store';
import { SegmentEditor, useSegmentEditorState } from '@starflow/app/components/common/SegmentEditor';
import { smartRemoveShapesFromImage } from './helper';
import { viewportActions } from '@starflow/app/store';

const SmartRemoveEditor = React.memo((props) => {
  const { element } = props;
  const removing = useLoadings(element.id + '-removing');
  const [editorState, setEditorState, getEditorState] = useSegmentEditorState();
  const { selections } = editorState.value;
  const allowRemove = selections?.length > 0;

  console.log('[DEBUG] editorState', editorState);

  const handleConfirmRemove = useCallback(async () => {
    smartRemoveShapesFromImage(element, getEditorState().selections).then(() => {
      setEditorState({ selections: [] });
    });
  }, [element]);

  const config = useMemo(() => {
    return {
      noSegment: true,
      noAutoSelection: true,
      showToolbar: true,
      noFeathering: true,
      noInvert: true,
      toolbarRightButton: (
        <button
          disabled={!allowRemove}
          onClick={handleConfirmRemove}
          className="h-8 ml-2 px-3 disabled:bg-[#999] bg-primary-dark pointer-events-auto text-white text-xs whitespace-nowrap rounded-md"
        >
          {translate(removing ? 'remove_button_loading' : translate('remove_button'))}
        </button>
      ),
    };
  }, [removing, element, allowRemove]);

  useEffect(() => {
    viewportActions.locateElement(element.id, { animate: true, fitView: true });
  }, [element.id]);

  return (
    <SegmentEditor
      config={config}
      element={element}
      editorState={editorState}
      setEditorState={setEditorState}
      getEditorState={getEditorState}
      className="outline outline-2 outline-primary"
    />
  );
});

export const wrapImageOverlayer = (Overlayer) =>
  React.memo((props) => {
    const { currentElementTool, editingElementId, element } = props;
    const isActive = currentElementTool === 'smartRemove' && editingElementId === element.id;

    if (isActive) {
      return <SmartRemoveEditor element={element} />;
    }

    return <Overlayer {...props} />;
  });
